module.exports = __webpack_public_path__ + "components/country-flag/static/dk-e629c8e698337269bf184aabcc1a96ea.svg";